const tools = [
    // Development Environments
    { key: 'VSCode', name: 'VS Code' },
    { key: 'sublime', name: 'Sublime' },
    // Version Control
    { key: 'GitHub', name: 'GitHub' },
    // Package Managers
    { key: 'composer', name: 'Composer' },
    { key: 'npm', name: 'NPM' },
    // APIs and Testing
    { key: 'postman', name: 'Postman' },
    // CI/CD Tools
    { key: 'Jenkins', name: 'Jenkins' },
    // UI/UX
    { key: 'adobe-xd', name: 'Adobe XD' },
    { key: 'figma', name: 'Figma' },
    // Web Servers
    { key: 'nginx', name: 'Nginx' },
    { key: 'Apache', name: 'Apache' },
    // Others
    { key: 'slack', name: 'Slack' },
    { key: 'asana', name: 'Asana' },
];
function Tools() {
    return (
        <div className="tools-section">
            <div className="tools-grid">
                {
                    tools.map(entry => {
                        return (
                            <div className="tool-card bg-white dark:bg-khi-700" key={entry.key}>
                                <div className="tool-icon">
                                    <img src={`img/web-dev/${entry.key}.png`} alt={entry.key} />
                                </div>
                                <div className="tool-name text-khi-50">{entry.name}</div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Tools